import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function PrivacidadPage() {
  const { currentTheme: t } = useTheme();

  const sectionStyle = {
    color: t.textSecondary,
    fontFamily: 'Inter, sans-serif',
  };

  const headingStyle = {
    color: t.text,
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Hero */}
      <section className="pt-28 lg:pt-36 pb-12" style={{ background: t.heroBg }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl lg:text-5xl font-bold mb-4" style={headingStyle}>
            Política de Privacidad
          </motion.h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16" style={{ background: t.bg }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose max-w-none space-y-8">
            {/* General */}
            <div>
              <h2 className="text-2xl font-bold mb-4" style={headingStyle}>Política de Privacidad General de Motivy</h2>
              <div className="space-y-4 text-sm leading-relaxed" style={sectionStyle}>
                <p><strong style={{ color: t.text }}>Titular:</strong> Motivy, Inc. — Email: info@motivy.co</p>
                <p><strong style={{ color: t.text }}>Consentimiento:</strong> Aceptación libre, informada, específica e inequívoca.</p>
                <p><strong style={{ color: t.text }}>Datos obligatorios:</strong> Requeridos para formularios de acceso/registro.</p>
                <p><strong style={{ color: t.text }}>Datos recopilados:</strong> Dispositivo, navegación, geolocalización, datos identificativos, datos de contacto.</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>4.1 Datos de salud</h3>
                <p>Metabolismo basal, porcentaje de grasa corporal, peso, altura, pasos diarios, distancia, minutos de actividad, sueño (solo con autorización expresa).</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>Finalidades</h3>
                <p>Alta de usuario, gestión de perfil, comunicaciones, peticiones, envío de productos/beneficios, gestión de demos, cumplimiento legal.</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>Legitimación</h3>
                <p>Consentimiento del usuario.</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>Terceros</h3>
                <p>Motivy no cede datos a terceras empresas.</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>Derechos</h3>
                <p>Revocar consentimiento, acceder, rectificar, suprimir, limitar, portabilidad — Email: info@motivy.com</p>
                
                <h3 className="text-lg font-semibold mt-6" style={headingStyle}>Seguridad</h3>
                <p>Tratamiento confidencial con medidas técnicas y organizativas.</p>
                
                <p className="text-xs mt-6" style={{ color: t.textMuted }}>Última actualización: 16 de Septiembre del 2020</p>
              </div>
            </div>

            {/* FitRewards */}
            <div className="pt-8 border-t" style={{ borderColor: t.borderColor }}>
              <h2 className="text-2xl font-bold mb-4" style={headingStyle}>Política de Privacidad FitRewards</h2>
              <div className="space-y-4 text-sm leading-relaxed" style={sectionStyle}>
                <p><strong style={{ color: t.text }}>Datos de cuenta:</strong> nombre, correo electrónico institucional, ID de usuario, credenciales.</p>
                <p><strong style={{ color: t.text }}>Datos de actividad física y salud:</strong> pasos, calorías, distancia, frecuencia cardíaca (via Apple HealthKit / Google Fit).</p>
                <p><strong style={{ color: t.text }}>Datos de uso:</strong> interacción con funcionalidades, estadísticas de participación, progreso en retos.</p>
                <p><strong style={{ color: t.text }}>Uso:</strong> Optimizar experiencia, integración con servicios de bienestar, métricas internas, obligaciones legales.</p>
                <p><strong style={{ color: t.text }}>Terceros:</strong> Datos de HealthKit/Google Fit no se comparten sin consentimiento explícito.</p>
                <p><strong style={{ color: t.text }}>Contacto:</strong> info@motivy.co | +1 305-788-1740</p>
                <p className="text-xs mt-6" style={{ color: t.textMuted }}>Última actualización: 28/08/2025</p>
              </div>
            </div>

            {/* Link to full FitRewards privacy */}
            <div className="pt-8 border-t text-center" style={{ borderColor: t.borderColor }}>
              <Link
                to="/politica-de-privacidad/fitrewards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold transition-colors duration-200"
                style={{ background: t.featureIconBg, color: t.featureIconColor }}
              >
                Ver política completa de FitRewards →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
